(function () {
  'use strict';

  var STOREFRONT_ENDPOINT = 'https://switchbot.jp/api/2026-07/graphql.json';
  var STOREFRONT_TOKEN = 'a68c8cd7c1e719c6d5e86a8f7b90d1d1';

  var COLLECTION_QUERY = [
    'query CustomCollectionProducts($handle: String!, $sortKey: ProductCollectionSortKeys!, $reverse: Boolean!) {',
    '  collection(handle: $handle) {',
    '    products(first: 250, sortKey: $sortKey, reverse: $reverse) {',
    '      nodes {',
    '        id',
    '        title',
    '        handle',
    '        images(first: 1) { nodes { url altText } }',
    '        variants(first: 1) { nodes { id price { amount currencyCode } } }',
    '        priceRange { minVariantPrice { amount currencyCode } }',
    '      }',
    '    }',
    '  }',
    '}'
  ].join('\n');

  var SORT_OPTIONS = {
    BEST_SELLING: { sortKey: 'BEST_SELLING', reverse: false },
    MANUAL: { sortKey: 'MANUAL', reverse: false },
    CREATED_DESC: { sortKey: 'CREATED', reverse: true },
    PRICE_ASC: { sortKey: 'PRICE', reverse: false },
    PRICE_DESC: { sortKey: 'PRICE', reverse: true }
  };

  var SORT_LABELS = {
    BEST_SELLING: 'ベストセラー',
    MANUAL: 'おすすめ順',
    CREATED_DESC: '新作順',
    PRICE_ASC: '価格の低い順',
    PRICE_DESC: '価格の高い順'
  };

  function parseJson(root, selector) {
    var node = root.querySelector(selector);
    if (!node) return {};
    var value = (node.textContent || '').trim();
    if (!value || value === 'null') return {};

    try {
      return JSON.parse(value) || {};
    } catch (error) {
      return {};
    }
  }

  function numericId(gid) {
    if (!gid) return '';
    var parts = String(gid).split('/');
    return parts[parts.length - 1];
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function safeProductUrl(handle) {
    return '/products/' + encodeURIComponent(String(handle || ''));
  }

  function formatPrice(amount, symbol) {
    var number = Number(amount);
    if (!Number.isFinite(number)) return 'Unknown';
    return (symbol || '¥') + Math.round(number).toLocaleString('ja-JP');
  }

  function productCardMarkup(product, symbol) {
    var labels = product.commonConfig && product.commonConfig.configLabels
      ? String(product.commonConfig.configLabels).split(',').join(' | ')
      : '';
    var description = product.commonConfig && product.commonConfig.configDesc
      ? product.commonConfig.configDesc
      : '';
    var badges = '';

    if (product.discountConfig && product.discountConfig.point && product.discountConfig.point.number) {
      badges += '<div class="my-custom-prod-item-dc-item">' + escapeHtml(product.discountConfig.point.number) + '</div>';
    }
    if (product.discountConfig && product.discountConfig.direct && product.discountConfig.direct.number) {
      badges += '<div class="my-custom-prod-item-dc-item">' + escapeHtml(product.discountConfig.direct.number) + '</div>';
    }

    var image = '';
    if (product.imageUrl) {
      image = '<img src="' + escapeHtml(product.imageUrl) + '" alt="' + escapeHtml(product.imageAlt || product.rawTitle) + '" width="480" height="480" loading="lazy" class="my-custom-prod-item-img-wrap-img">';
    }

    var price = formatPrice(product.price, symbol) + '（税込）';

    return [
      '<div class="my-custom-collection-prod-item-wrap" data-variant-id="', escapeHtml(product.variantId), '">',
      '<a target="_self" href="', safeProductUrl(product.handle), '" class="my-custom-prod-item-awrap">',
      '<div class="my-custom-prod-item-content">',
      '<div class="my-custom-prod-item-saveId" style="height:1px;visibility:hidden">', escapeHtml(product.productId), '</div>',
      '<div class="my-custom-prod-item-dc">', badges, '</div>',
      '<div class="my-custom-prod-item-hover-wrap">',
      '<div class="my-custom-prod-item-hover-price"><span class="my-custom-prod-item-hover-spanprice">', escapeHtml(price), '</span></div>',
      '<div class="my-custom-prod-item-hover-btn" aria-hidden="true">',
      '<svg viewBox="0 0 22 22" width="22" height="22"><path d="M11 1.5v19M1.5 11h19" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round"/></svg>',
      '</div></div>',
      '<div class="my-custom-prod-item-img-wrap"><div class="my-custom-prod-item-img-content">', image, '</div></div>',
      '<div class="my-custom-prod-item-middle-wrap">',
      '<div class="my-custom-prod-item-label">', escapeHtml(labels), '</div>',
      '<div class="my-custom-prod-item-name">', escapeHtml(product.title), '</div>',
      '<div class="my-custom-prod-item-desc">', escapeHtml(description), '</div>',
      '</div>',
      '<div class="my-custom-prod-item-bottom-wrap">',
      '<div class="my-custom-prod-item-bottom-price">', escapeHtml(price), '</div>',
      '<div class="my-custom-prod-item-bottom-icon" aria-hidden="true">',
      '<svg viewBox="0 0 25 22" width="25" height="22" fill="none"><path d="M2 2h3l2.2 12h13.3l2-8.3H6M9 20a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM19 20a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      '</div></div>',
      '</div></a></div>'
    ].join('');
  }

  function CustomCollectionPage(root) {
    this.root = root;
    this.handle = root.dataset.collectionHandle || '';
    this.pageSize = Number(root.dataset.pageSize) || 12;
    this.moneySymbol = root.dataset.moneySymbol || '¥';
    this.grid = root.querySelector('[data-collection-grid]');
    this.loading = root.querySelector('[data-collection-loading]');
    this.empty = root.querySelector('[data-collection-empty]');
    this.pagination = root.querySelector('[data-collection-pagination]');
    this.commonConfig = parseJson(root, '[data-collection-common-config]');
    this.discountConfig = parseJson(root, '[data-collection-discount-config]');
    this.products = [];
    this.filter = 'all';
    this.sort = 'MANUAL';
    this.page = 1;
    this.requestId = 0;
  }

  CustomCollectionPage.prototype.init = function () {
    this.bindEvents();
    this.decorateServerCards();
    this.updateCount(this.grid ? this.grid.querySelectorAll('.my-custom-collection-prod-item-wrap').length : 0);
    this.fetchProducts();
  };

  CustomCollectionPage.prototype.bindEvents = function () {
    var self = this;

    this.root.addEventListener('click', function (event) {
      var filterButton = event.target.closest('[data-collection-filter]');
      if (filterButton && self.root.contains(filterButton)) {
        self.setFilter(filterButton.dataset.collectionFilter || 'all');
        var details = filterButton.closest('details');
        if (details) details.removeAttribute('open');
        return;
      }

      var sortOption = event.target.closest('[data-collection-sort-option]');
      if (sortOption && self.root.contains(sortOption)) {
        self.setSort(sortOption.dataset.collectionSortOption || 'MANUAL');
        return;
      }

      var sortToggle = event.target.closest('[data-collection-sort-toggle]');
      if (sortToggle && self.root.contains(sortToggle)) {
        self.toggleSortMenu();
        return;
      }

      var pageButton = event.target.closest('[data-collection-page]');
      if (pageButton && !pageButton.disabled) {
        self.setPage(Number(pageButton.dataset.collectionPage));
      }
    });

    this.root.addEventListener('change', function (event) {
      if (!event.target.matches('[data-collection-sort]')) return;
      self.setSort(event.target.value);
    });

    this.root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') self.closeSortMenu();
    });

    document.addEventListener('click', function (event) {
      var sortControl = event.target.closest('[data-collection-sort-control]');
      if (!sortControl || !self.root.contains(sortControl)) self.closeSortMenu();
    });
  };

  CustomCollectionPage.prototype.toggleSortMenu = function () {
    var menu = this.root.querySelector('[data-collection-sort-menu]');
    if (!menu) return;
    if (menu.hidden) {
      menu.hidden = false;
      this.root.querySelectorAll('[data-collection-sort-toggle]').forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', 'true');
      });
    } else {
      this.closeSortMenu();
    }
  };

  CustomCollectionPage.prototype.closeSortMenu = function () {
    var menu = this.root.querySelector('[data-collection-sort-menu]');
    if (!menu || menu.hidden) return;
    menu.hidden = true;
    this.root.querySelectorAll('[data-collection-sort-toggle]').forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    });
  };

  CustomCollectionPage.prototype.setSort = function (sort) {
    var self = this;
    if (!SORT_OPTIONS[sort]) return;

    this.sort = sort;
    this.page = 1;
    this.root.querySelectorAll('[data-collection-sort]').forEach(function (select) {
      select.value = self.sort;
    });
    this.root.querySelectorAll('[data-collection-sort-option]').forEach(function (option) {
      var active = option.dataset.collectionSortOption === self.sort;
      option.classList.toggle('my-custom-pc-collection-sort-select-item-active', active);
      option.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    var label = this.root.querySelector('.my-custom-pc-collection-sort-content-text');
    if (label) label.textContent = SORT_LABELS[this.sort];

    this.closeSortMenu();
    this.fetchProducts();
  };

  CustomCollectionPage.prototype.decorateServerCards = function () {
    var self = this;
    if (!this.grid) return;

    this.grid.querySelectorAll('.my-custom-collection-prod-item-wrap').forEach(function (card) {
      var idNode = card.querySelector('.my-custom-prod-item-saveId');
      var productId = idNode ? (idNode.textContent || '').trim() : '';
      var variantId = (card.dataset.variantId || '').trim();
      var common = self.commonConfig[productId];
      var discount = self.getVariantDiscount(productId, variantId);

      if (common) {
        var label = card.querySelector('.my-custom-prod-item-label');
        var description = card.querySelector('.my-custom-prod-item-desc');
        if (label && common.configLabels) label.textContent = String(common.configLabels).split(',').join(' | ');
        if (description && common.configDesc) description.textContent = common.configDesc;
      }

      if (discount) {
        var badgeContainer = card.querySelector('.my-custom-prod-item-dc');
        var badges = [];
        if (discount.point && discount.point.number) badges.push(discount.point.number);
        if (discount.direct && discount.direct.number) badges.push(discount.direct.number);
        if (badgeContainer) {
          badgeContainer.innerHTML = badges.map(function (badge) {
            return '<div class="my-custom-prod-item-dc-item">' + escapeHtml(badge) + '</div>';
          }).join('');
        }
      }
    });
  };

  CustomCollectionPage.prototype.fetchProducts = function () {
    var self = this;
    var sort = SORT_OPTIONS[this.sort] || SORT_OPTIONS.MANUAL;
    var currentRequest = ++this.requestId;
    this.setLoading(true);

    fetch(STOREFRONT_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({
        query: COLLECTION_QUERY,
        variables: {
          handle: this.handle,
          sortKey: sort.sortKey,
          reverse: sort.reverse
        }
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Storefront API request failed: ' + response.status);
        return response.json();
      })
      .then(function (payload) {
        if (currentRequest !== self.requestId) return;
        if (payload.errors && payload.errors.length) throw new Error(payload.errors[0].message);
        var nodes = payload.data && payload.data.collection && payload.data.collection.products
          ? payload.data.collection.products.nodes
          : [];
        self.products = nodes.map(function (node) { return self.mapProduct(node); });
        self.page = 1;
        self.render();
      })
      .catch(function (error) {
        if (currentRequest !== self.requestId) return;
        console.error('[Custom collection]', error);
        self.root.setAttribute('data-api-error', 'true');
      })
      .finally(function () {
        if (currentRequest === self.requestId) self.setLoading(false);
      });
  };

  CustomCollectionPage.prototype.mapProduct = function (node) {
    var productId = numericId(node.id);
    var variants = node.variants && node.variants.nodes ? node.variants.nodes : [];
    var firstVariant = variants[0] || {};
    var variantId = numericId(firstVariant.id);
    var images = node.images && node.images.nodes ? node.images.nodes : [];
    var firstImage = images[0] || {};
    var price = firstVariant.price && firstVariant.price.amount != null
      ? firstVariant.price.amount
      : node.priceRange && node.priceRange.minVariantPrice
        ? node.priceRange.minVariantPrice.amount
        : null;
    var discount = this.getVariantDiscount(productId, variantId);

    return {
      productId: productId,
      variantId: variantId,
      rawTitle: node.title || '',
      title: String(node.title || '').replace(/switchbot/gi, '').trim(),
      handle: node.handle || '',
      price: price,
      imageUrl: firstImage.url || '',
      imageAlt: firstImage.altText || '',
      commonConfig: this.commonConfig[productId] || null,
      discountConfig: discount
    };
  };

  // 两个新字段独立匹配，商品或变体缺失时该类型无折扣；不回退旧配置。
  CustomCollectionPage.prototype.getVariantDiscount = function (productId, variantId) {
    return {
      direct: this.discountConfig.direct?.[productId]?.[variantId]?.direct,
      point: this.discountConfig.point?.[productId]?.[variantId]?.point
    };
  };

  CustomCollectionPage.prototype.filteredProducts = function () {
    if (this.filter === 'sale') {
      return this.products.filter(function (product) {
        var discount = product.discountConfig;
        return Boolean(discount && ((discount.point && discount.point.number) || (discount.direct && discount.direct.number)));
      });
    }

    if (this.filter === 'combo') {
      return this.products.filter(function (product) {
        return product.rawTitle.indexOf('セット') !== -1;
      });
    }

    return this.products;
  };

  CustomCollectionPage.prototype.setFilter = function (filter) {
    this.filter = filter;
    this.page = 1;
    this.root.querySelectorAll('[data-collection-filter]').forEach(function (button) {
      var active = button.dataset.collectionFilter === filter;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    this.render(true);
  };

  CustomCollectionPage.prototype.setPage = function (page) {
    var totalPages = Math.max(1, Math.ceil(this.filteredProducts().length / this.pageSize));
    this.page = Math.min(Math.max(page || 1, 1), totalPages);
    this.render(true);
  };

  CustomCollectionPage.prototype.render = function (shouldScroll) {
    if (!this.grid) return;
    var products = this.filteredProducts();
    var start = (this.page - 1) * this.pageSize;
    var visible = products.slice(start, start + this.pageSize);

    this.grid.innerHTML = visible.map(function (product) {
      return productCardMarkup(product, this.moneySymbol);
    }, this).join('');

    if (this.empty) this.empty.hidden = visible.length !== 0;
    this.updateCount(products.length);
    this.renderPagination(products.length);

    if (shouldScroll) {
      var anchor = this.root.querySelector('.custom-collection-anchor');
      if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  CustomCollectionPage.prototype.updateCount = function (count) {
    this.root.querySelectorAll('[data-collection-count]').forEach(function (node) {
      node.textContent = count + ' Item(s) Found';
    });
  };

  CustomCollectionPage.prototype.renderPagination = function (total) {
    if (!this.pagination) return;
    var totalPages = Math.ceil(total / this.pageSize);
    if (totalPages <= 1) {
      this.pagination.innerHTML = '';
      return;
    }

    var html = '<button type="button" class="custom-collection-page-button" data-collection-page="' + (this.page - 1) + '" aria-label="前のページ"' + (this.page === 1 ? ' disabled' : '') + '>‹</button>';
    for (var index = 1; index <= totalPages; index += 1) {
      html += '<button type="button" class="custom-collection-page-button' + (index === this.page ? ' is-active' : '') + '" data-collection-page="' + index + '" aria-label="' + index + 'ページ"' + (index === this.page ? ' aria-current="page"' : '') + '>' + index + '</button>';
    }
    html += '<button type="button" class="custom-collection-page-button" data-collection-page="' + (this.page + 1) + '" aria-label="次のページ"' + (this.page === totalPages ? ' disabled' : '') + '>›</button>';
    this.pagination.innerHTML = html;
  };

  CustomCollectionPage.prototype.setLoading = function (loading) {
    if (this.loading) this.loading.hidden = !loading;
    this.root.setAttribute('aria-busy', loading ? 'true' : 'false');
  };

  function initialize(scope) {
    (scope || document).querySelectorAll('[data-custom-collection-page]').forEach(function (root) {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      new CustomCollectionPage(root).init();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
